import React from "react"

import { KeyVisualChart } from "components/organisms/panel/KeyVisualChart"
import { IndexTableList } from "components/organisms/panel/tableList"
import { EconomicsIndex } from "components/organisms/panel/tableList"
import { MarketStatistics } from "components/organisms/panel/marketStatistics"
import { RankingSummaryPanel } from "components/organisms/panel/rankingSummary"
import { DomesticTodayCalender } from "components/organisms/panel/calendar"
import { NewsTopicsPanel } from "components/organisms/panel/newsTopics"
import { APIResponse } from "redux/apis/types"
import { Sort } from "utils/sort"
import { Panel } from "../../organisms/panel"
import { NewsListContent } from "../../molecules/list/news"
import { NewsList } from "components/organisms/panel/newsList"
import { history } from "config/const"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { DataDescription } from "../../organisms/panel/dataDescription"
import { checkIsSp } from "utils/util"
import { WorldSummaryDisclaimerText } from "config/disclaimerText"

type RankingDataType = {
  exchangeTypeNum: number
  priceIncreaseList: Array<object>
  priceReductionList: Array<object>
  volumeList: Array<object>
  priceIncreaseTime: string
  priceReductionTime: string
  volumeTime: string
}

type Props = {
  chartData: Array<object>
  indexData: Array<object>
  changeIndex: Function
  indicatorListData: Array<object>
  changeIndicatorList: Function
  statisticsData: APIResponse.Res
  rankingData: RankingDataType
  changeRanking: Function
  callRankingApi: Function
  calenderData: APIResponse.Res
  history: history
  topFlag?: boolean
  updateFuncList: {
    chart: Function
    index: Function
    statistics: Function
    ranking: Function
    indicator: Function
    calender: Function
  }
}

export const SummaryTemplate = (props: Props) => {
  const isPhone = checkIsSp()

  return (
    <MainContainer className="world-summary-template">
      <KeyVisualChart
        chartData={props.chartData}
        linkTechChart={!!props.topFlag}
      />
      <div className="symmetry-layout">
        <div className="contents-block">
          <div className="contents-nest-block">
            <IndexTableList
              indexData={props.indexData}
              changeIndex={props.changeIndex}
              history={props.history}
            />
          </div>
          <div className="contents-nest-block">
            <MarketStatistics
              statisticsData={props.statisticsData}
              updateFunc={props.updateFuncList.statistics}
            />
          </div>
          <div className="contents-nest-block">
            <RankingSummaryPanel
              title="ランキング"
              rankingData={props.rankingData}
              exchangeList={Sort.WorldSummaryRankingExchange}
              changeRanking={props.changeRanking}
              callApi={props.callRankingApi}
            />
          </div>
        </div>
        <div className="contents-block">
          <div className="contents-nest-block">
            <NewsTopicsPanel />
          </div>
          <div className="contents-nest-block">
            <EconomicsIndex
              indicatorListData={props.indicatorListData}
              changeIndicatorList={props.changeIndicatorList}
              history={props.history}
            />
          </div>
          <div className="contents-nest-block">
            <DomesticTodayCalender
              calenderData={props.calenderData}
              updateFunc={props.updateFuncList.calender}
            />
          </div>
          {/*<NewsList route={ROUTE_LIST.TOP_SUMMARY} />*/}
        </div>
      </div>
      {!isPhone && (
        <DataDescription
          className="panel-data-description"
          children={WorldSummaryDisclaimerText}
        />
      )}
    </MainContainer>
  )
}
